import React from "react";
import { ReactComponent as BatchIcon } from "../../../../../assets/Icons/Setting/Profile/TeamBatch.svg";
// import { ReactComponent as BatchIcon } from "../../../../../";

const PositionViewer = ({ position, color }) => {
  return (
    <div className="flex-col align-center justify-start g-1" style={{width:"5rem"}}>
      <BatchIcon fill={color} style={{ width: "2.4rem" }} />
      <span className="poppins t-12 color-textColor text-align-center">{position}</span>
    </div>
  );
};

export default PositionViewer;
